import { Spin } from "antd";
import React from "react";
import "./style.scss";

const DetailLoading = () => {
  return (
    <div className="detail-blood-order-loading">
      <Spin tip="Loading..." size="large">
        {/* <div
          style={{
            padding: 50,
            background: "rgba(0, 0, 0, 0.05)",
            borderRadius: 4,
          }}
        /> */}
      </Spin>
    </div>
  );
};

export default DetailLoading;
